import type { SelectItem, ServiceType } from '../types';
import type { AvailableView } from '@allibee/service';

/**
 * 태그 업데이트 함수
 */
export const updateTags = (selectedCountryTags: AistudioAiTagDto[], tagType: 'DATA_TYPE' | 'EXPERTISE_AREA'): SelectItem[] =>
    selectedCountryTags
        .filter(tag => tag.tagType === tagType)
        .map(tag => ({
            value: tag.code,
            label: tag.name,
            disabled: tag.editable === false,
            active: tag.active,
            ...(tagType === 'EXPERTISE_AREA' ? { tagField: tag.tagField } : {}),
        }));

/**
 * 필터링된 카테고리 업데이트 함수
 */
export const updateFilteredCategories = (categoryResponse: AistudioAiCategoryWithTagDto[], selectedServiceType: ('WORKSPACE' | 'GENERAL' | 'WEB')[], selectedCountry: SelectItem | null) => {
    const isWorkspaceSelected = selectedServiceType.some(item => item === 'WORKSPACE');
    const isGeneralSelected = selectedServiceType.some(item => item === 'GENERAL');
    const selectedCountryValue = selectedCountry?.value;

    return categoryResponse.filter(
        category =>
            (isWorkspaceSelected && category.serviceType === 'WORKSPACE') ||
            (isGeneralSelected && category.serviceType === 'GENERAL' && (!selectedCountryValue || category.country === selectedCountryValue)),
    );
};

/**
 * 서비스 타입이 최소 1개 선택되도록 보장
 */
export const ensureServiceTypes = <T extends ServiceType>(types: T[]): T[] => (types.length > 0 ? types : (['WORKSPACE'] as T[]));

/**
 * 아이템과 매칭되는 뷰를 찾습니다.
 */
export const findMatchingView = (item: { serviceType: string; categoryType?: string }, availableViews: AvailableView[]): AvailableView | undefined => {
    const itemServiceType = item.serviceType;
    const itemCategoryType = item.categoryType;

    return (
        availableViews.find(view => view.filters.serviceType === itemServiceType && (view.filters.categoryType ? view.filters.categoryType === itemCategoryType : true)) ||
        availableViews.find(view => view.filters.serviceType === itemServiceType && !view.filters.categoryType)
    );
};
